export const GET_CAREER_AUTHORS = "GET_CAREER_AUTHORS";
export const GET_CAREER_AUTHOR_BY_ID = "GET_CAREER_AUTHOR_BY_ID";
export const UPDATE_CAREER_AUTHOR = "UPDATE_CAREER_AUTHOR";
export const DELETE_CAREER_AUTHOR = "DELETE_CAREER_AUTHOR";
export const CREATE_CAREER_AUTHOR = "CREATE_CAREER_AUTHOR";
